export default {
  badge: 'สัญลักษณ์',
  open: 'เปิด',
  close: 'ปิด',
  dismiss: 'ยกเลิก',
  confirmEdit: {
    ok: 'ตกลง',
    cancel: 'ยกเลิก',
  },
  dataIterator: {
    noResultsText: 'ไม่พบข้อมูลที่ค้นหา',
    loadingText: 'กำลังโหลดข้อมูล...',
  },
  dataTable: {
    itemsPerPageText: 'แถวต่อหน้า:',
    ariaLabel: {
      sortDescending: 'เรียงจากมากไปน้อยอยู่',
      sortAscending: 'เรียงจากน้อยไปมากอยู่',
      sortNone: 'ไม่ได้เรียงลำดับ',
      activateNone: 'กดเพื่อปิดการเรียงลำดับ',
      activateDescending: 'กดเพื่อเรียงจากมากไปน้อย',
      activateAscending: 'กดเพื่อเรียงจากน้อยไปมาก',
    },
    sortBy: 'เรียงตาม',
  },
  dataFooter: {
    itemsPerPageText: 'รายการต่อหน้า:',
    itemsPerPageAll: 'ทั้งหมด',
    nextPage: 'หน้าต่อไป',
    prevPage: 'หน้าที่แล้ว',
    firstPage: 'หน้าแรก',
    lastPage: 'หน้าสุดท้าย',
    pageText: '{0}-{1} จาก {2}',
  },
  dateRangeInput: {
    divider: 'ถึง',
  },
  datePicker: {
    itemsSelected: 'เลือกแล้ว {0} รายการ',
    range: {
      title: 'เลือกวันที่',
      header: 'ป้อนวันที่',
    },
    title: 'เลือกวันที่',
    header: 'ป้อนวันที่',
    input: {
      placeholder: 'ป้อนวันที่',
    },
  },
  noDataText: 'ไม่มีข้อมูล',
  carousel: {
    prev: 'ภาพก่อนหน้า',
    next: 'ภาพถัดไป',
    ariaLabel: {
      delimiter: 'ภาพสไลด์ที่ {0} จาก {1}',
    },
  },
  calendar: {
    moreEvents: 'มีอีก {0}',
    today: 'วันนี้',
  },
  input: {
    clear: 'ล้าง {0}',
    prependAction: 'การกระทำก่อนหน้า {0}',
    appendAction: 'การกระทำเพิ่มเติม {0}',
    otp: 'กรุณากรอกตัวอักษร OTP ตัวที่ {0}',
  },
  fileInput: {
    counter: '{0} ไฟล์',
    counterSize: '{0} ไฟล์ (รวม {1})',
  },
  fileUpload: {
    title: 'ลากและวางไฟล์ที่นี่',
    divider: 'หรือ',
    browse: 'เลือกไฟล์',
  },
  timePicker: {
    am: 'ช่วงเช้า',
    pm: 'ช่วงบ่าย',
    title: 'เลือกเวลา',
  },
  pagination: {
    ariaLabel: {
      root: 'การนำทางไปยังหน้า',
      next: 'หน้าต่อไป',
      previous: 'หน้าที่แล้ว',
      page: 'ไปที่หน้า {0}',
      currentPage: 'หน้าปัจจุบัน (หน้า {0})',
      first: 'หน้าแรก',
      last: 'หน้าสุดท้าย',
    },
  },
  stepper: {
    next: 'ถัดไป',
    prev: 'ก่อนหน้า',
  },
  rating: {
    ariaLabel: {
      item: 'คะแนน {0} จาก {1}',
    },
  },
  loading: 'กำลังโหลด...',
  infiniteScroll: {
    loadMore: 'โหลดเพิ่มเติม',
    empty: 'ไม่มีข้อมูลเพิ่มเติม',
  },
  rules: {
    required: 'ช่องนี้จำเป็นต้องกรอก',
    email: 'กรุณากรอกอีเมลที่ถูกต้อง',
    number: 'ช่องนี้สามารถมีเฉพาะตัวเลขเท่านั้น',
    integer: 'ช่องนี้สามารถมีเฉพาะจำนวนเต็มเท่านั้น',
    capital: 'ช่องนี้สามารถมีเฉพาะตัวพิมพ์ใหญ่เท่านั้น',
    maxLength: 'คุณต้องกรอกสูงสุด {0} อักขระ',
    minLength: 'คุณต้องกรอกขั้นต่ำ {0} อักขระ',
    strictLength: 'ความยาวของช่องที่กรอกไม่ถูกต้อง',
    exclude: 'อักขระ {0} ไม่ได้รับอนุญาต',
    notEmpty: 'กรุณาเลือกอย่างน้อยหนึ่งค่า',
    pattern: 'รูปแบบไม่ถูกต้อง',
  },
}
